import { Component } from '@theme/component';

/**
 * Announcement banner custom element that allows fading between content.
 * Based on the Slideshow component.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} slideshowContainer
 * @property {HTMLElement[]} [slides]
 * @property {HTMLButtonElement} [previous]
 * @property {HTMLButtonElement} [next]
 *
 * @extends {Component<Refs>}
 */
export class KaipiFaq extends Component {

  connectedCallback() {
    super.connectedCallback();

    this.jsonData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": []
    };

    var qa = [];
    this.querySelectorAll('accordion-custom').forEach((item) => this.manageAccordionEntry(item));

    this.appendJson(JSON.stringify(this.jsonData));
  }

  manageAccordionEntry(item) {
    var question, answer;
    question = item.querySelector('summary').innerText;
    answer = item.querySelector('.details-content').textContent.trim();
    this.addQuestionAnswer(question, answer);
  }

  addQuestionAnswer(question, answer) {
        this.jsonData.mainEntity.push({
            "@type": "Question",
            "name": question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": answer
            }
        });
  }
  appendJson(json) {
      const script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.textContent = json;
      document.head.appendChild(script);
  }


  /**
   * Pause the slideshow when the page is hidden.
   */
  #handleVisibilityChange = () => (document.hidden ? this.pause() : this.resume());
}

if (!customElements.get('kaipi-faq')) {
  customElements.define('kaipi-faq', KaipiFaq);
}
